// extracted by mini-css-extract-plugin
export var messageSideLeft = "_mn-1";
export var messageSideRight = "_mn-2";
export var subscribeToBackInStockBubbleContainer = "_mn-0";